import React, {useEffect} from 'react';

import {observer} from "mobx-react";
import {EntityScoresWidgetAsync} from "../../../../../widgets/entity-scores-widget/components/entity-scores-widget.async";
import {ENTITY_SCORES} from "../../../../../widgets/entity-scores-widget/entity-scores-widget.consts";
import {SideBarModuleTabs} from "./side-bar-module.tabs";
import FilterBarModule from "../../../../../modules/filter-bar-module/components/filter-bar-module";
import {useLocation} from "react-router-dom";
import {SIDE_BAR} from "../side-bar-module.consts";
import classNames from "classnames";
import styles from "../styles/side-bar.module.scss";

export const SideBarModuleEntityScores = observer(({controller}) => {
  const location = useLocation();
  const {state} = controller;
  const {
    isCompetitionScores,
    selectedFilterName,
    currentLinkModel,
    isEntityScores,
    entityId,
    showOdds,
    isLive,
    date
  } = state;

  useEffect(() => {
    controller.action(SIDE_BAR.ACTION_TYPES.onTabClick, {index: 0});
  }, [entityId]);

  const baseProps = {
    context: isCompetitionScores ? ENTITY_SCORES.TYPES.competition : ENTITY_SCORES.TYPES.competitor,
    filterName: selectedFilterName,
    match: currentLinkModel,
    isSideBar: true,
    id: entityId,
    showOdds,
    entityId,
    location,
    isLive,
    date
  }

  const competitionScoresProps = {
    competitionId: entityId,
    ...baseProps
  }

  const competitorScoresProps = {
    competitorId: entityId,
    ...baseProps
  }

  const entityScoresProps = isCompetitionScores ? competitionScoresProps : competitorScoresProps;

  return isEntityScores ? <div className={classNames(styles.entity_scores_container)}>
    <SideBarModuleTabs controller={controller}/>
    <FilterBarModule controller={controller}/>
    <EntityScoresWidgetAsync {...entityScoresProps}/>
  </div> : null
});
